import React, { useEffect, useState } from "react";
import placeholderGiftCard from "../static/GenericBlackGiftCard-800px.png";
import { Container, Row, Col, Card } from "react-bootstrap";
import CombinedOffersPaginationComponent from "./CombinedOffersPaginationComponent";
import {getRegClaimedLegacyOffers, getRegClaimedOffers} from "../actions/registeredUserAction";
import {useSelector} from "react-redux";
import Loader from "./Loader";

const ClaimedGiftCardsPaged = ({ userInfo }) => {

  // Get the registered user data from the Redux store
  const regUserData = useSelector((state) => state.registeredUserDetails);
  const {getClaimedLoading, getClaimedError, getClaimedLegacyLoading, getClaimedLegacyError, userData} = regUserData;

  // Get the claimed gift cards and legacy gift cards from the Redux store
  const { claimedGiftCards, claimedLegacyGiftCards } = userData;

  // Get total pages from the registered user data
  const totalModernPages = claimedGiftCards?.page?.totalPages || 0;
  const totalLegacyPages = claimedLegacyGiftCards?.page?.totalPages || 0;

  // State variable to manage the current page
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE || 20);

  // Determine which offers to display
  const offersToDisplay =
    currentPage < totalModernPages
      ? claimedGiftCards?.content
      : claimedLegacyGiftCards?.content;

  // Only display the legacy hint if there are legacy pages and we are on the last modern page
  const displayLegacyHint =
    totalLegacyPages > 0 &&
    currentPage === totalModernPages - 1;

  // Handlers for pagination
  const handlePrevPage = () =>
    setCurrentPage((p) => Math.max(p - 1, 0));
  const handleNextPage = () =>
    setCurrentPage((p) => Math.min(p + 1, totalModernPages + totalLegacyPages - 1));

  return (
    <Container fluid className="gcotg-claimed-gc-container">
      <Row>
        <Col>
            <h3 className="claimed-gc-header">
              Claimed Gift Cards
            </h3>
        </Col>
      </Row>
      {(getClaimedLoading || getClaimedLegacyLoading) && (
        <Row>
          <Loader/>
          <strong>
            Fetching your gift cards. Please wait.
          </strong>
        </Row>
      )}
      {(getClaimedError || getClaimedLegacyError) && (
        <Row>
          <p className="order-error-msg">
            Unable to load claimed gift cards. Please log out and try again later.
          </p>
        </Row>
      )}
      {offersToDisplay?.length === 0 ? (
        <Row>
          <p>No claimed gift cards</p>
        </Row>
        ) : (
        <div>
          <Row>
            <p className="gcotg-claimed-gc-fine-print">
              {process.env.REACT_APP_REG_CLAIMED_GC_FINE_PRINT}
            </p>
            <CombinedOffersPaginationComponent
              currentPage={currentPage}
              pageSize={pageSize}
              totalModernPages={totalModernPages}
              totalLegacyPages={totalLegacyPages}
              modernPageFetchHandler={getRegClaimedOffers}
              legacyPageFetchHandler={getRegClaimedLegacyOffers}
              prevPageHandler={handlePrevPage}
              nextPageHandler={handleNextPage}
            />
          </Row>
          <Row className="justify-content-md-center">
            {offersToDisplay?.map((gcOffer) =>
              gcOffer.claimedGiftCards?.map((gcLink) => (
                <Col
                  md={4}
                  key={`${gcLink.id}`}
                  className="card-column"
                >
                  <Card>
                    <a href={gcLink.url} target="_blank" rel="noopener noreferrer" className="nounderline">
                      <Card.Img
                        variant="top"
                        src={
                          gcOffer.productImage
                            ? gcOffer.productImage
                            : placeholderGiftCard
                        }
                        loading="lazy"
                      />
                      <Card.Body>
                        <Card.Title>
                          {gcOffer?.isNew && (
                            <span className="new-claim-label">NEW</span>
                          )}
                          ${gcLink.amount} {gcOffer.brandName}
                        </Card.Title>
                        <Card.Text>
                    <span className="click-here-gc-text">
                      CLICK HERE TO VIEW
                    </span>
                          <span className="gc-fine-print">
                      <span className="gc-fine-print-line">
                        Swiped on {gcOffer.swipeDate}
                      </span>
                      <span className="gc-fine-print-line">
                        Offer # {gcOffer.ticketId}
                      </span>
                    </span>
                        </Card.Text>
                      </Card.Body>
                    </a>
                  </Card>
                </Col>
              ))
            )}
          </Row>
          <Row>
              {displayLegacyHint && currentPage === totalModernPages - 1 && (
                <p className="legacy-offers-hint">
                  More claimed gift cards available on the next page.
                </p>
              )}
          </Row>
          <Row>
            <CombinedOffersPaginationComponent
              currentPage={currentPage}
              pageSize={pageSize}
              totalModernPages={totalModernPages}
              totalLegacyPages={totalLegacyPages}
              modernPageFetchHandler={getRegClaimedOffers}
              legacyPageFetchHandler={getRegClaimedLegacyOffers}
              prevPageHandler={handlePrevPage}
              nextPageHandler={handleNextPage}
            />
          </Row>
          <Row>
            <Col>
              <p className="gcotg-claimed-gc-fine-print">
                {process.env.REACT_APP_REG_CLAIMED_GC_FINE_PRINT}
              </p>
            </Col>
          </Row>
        </div>
      )}
    </Container>
);
};

export default ClaimedGiftCardsPaged;
